/**
 * Reads the server error message out of a failed download. Downloads request a
 * blob response, so an error body arrives as a Blob rather than parsed JSON.
 */
export async function readBlobErrorMessage(error) {
  const data = error?.response?.data;

  if (!data) {
    return null;
  }

  if (typeof data.text !== 'function') {
    return data.error || null;
  }

  try {
    const parsed = JSON.parse(await data.text());
    return parsed?.error || null;
  } catch (parseError) {
    return null;
  }
}
